import { boot } from 'quasar/wrappers'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(( { app }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 10, // 15 minutes (list changes more often)
        gcTime: 1000 * 60 * 60, // 1 hour
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        retry: 3,
      },
    },
  })
  console.log('🟢 Vue Query boot — QueryClient initialized')
  app.use(VueQueryPlugin, { queryClient })
})
